// AssistantMarkdown.jsx — CHAT-3 isolated react-markdown wrapper for SETTLED assistant turns.
//
// Renders the durable, reconciled assistant prose so `**bold**`, paragraphs, and lists display
// correctly (fixes the literal-`**` + run-on wall from the chat screenshot). This is the ONLY
// place in the shell that imports react-markdown — keeping it isolated means assistantBlocks.js
// and renderPolicy.js stay import-free and `node --test`-verifiable, and the ESM/webpack cost of
// react-markdown is paid in exactly one module.
//
// SAFETY (multi-tenant; model-authored text is untrusted):
//   - NO rehype-raw and NO dangerouslySetInnerHTML. react-markdown@10 escapes raw HTML by
//     default, so model-authored `<script>`/`<img onerror>` renders as INERT literal text.
//   - Component map is CONSTRAINED to a known-safe subset (p, strong, em, code/pre, ul/ol/li, a,
//     and GFM tables). No headings/images/html.
//   - Links open in a new tab with rel="noopener noreferrer" (no reverse-tabnabbing / referrer leak).
//
// WIRING: AgentStudioChat renders the settled-assistant branch as <AssistantMarkdown text={t.text} />.
// User bubbles and the live typewriter delta stay plain text (renderPolicy.shouldMarkdownRender).

import React from "react"
import ReactMarkdown from "react-markdown"
// A5: the constrained component map now lives in a shared module so the streaming
// live-lane renderer (StreamingMarkdown.jsx) reuses the exact same known-safe subset.
import { COMPONENTS, REMARK_PLUGINS } from "./assistantMarkdownComponents.jsx"

/**
 * Render settled assistant markdown. The only plugin is remark-gfm (pipe tables) — explicitly
 * NO rehype-raw, so raw HTML in the model output stays inert escaped text.
 * @param {{ text?: string }} props
 */
export default function AssistantMarkdown({ text }) {
  return (
    <div className="st-md">
      <ReactMarkdown components={COMPONENTS} remarkPlugins={REMARK_PLUGINS}>{text || ""}</ReactMarkdown>
    </div>
  )
}
